export default __webpack_public_path__ + "static/media/composiciones_loading.e03aa3db.svg";